import React, { useEffect, useState } from "react";
import { CloseButton, Offcanvas } from "react-bootstrap";
import Tick from "assets/svgs/tick";
import _ from "lodash";
import { buttonStyle, formRow, selected} from "modules/dashboards/feedback_form/commonFunction";
import CallResponse from "modules/dashboards/feedback_form/CallResponse";

import { Button, Select, Space, Typography } from 'antd';
import { formDisposition } from 'config';
import { isEmpty } from 'lodash';
import SaveFeedBack from './SaveFeedBack';
import { useConsultDoctor, useTicketHistory } from "../actionables/store";
import moment from "moment";
import CustomerComplaintInterventionBooking from './CustomerComplaintInterventionBooking';
import { Descriptions } from 'antd';
import SoftBadge from "modules/common/SoftBadge";
import { DispositionComponent } from "../../lead_Detail_pop_up/DispositionComponent";
import { DISP_FLAG } from "../../utilities/utility";

function CustomerComplaintBookingDesposition({ bookingId, week, id, customerId, setBooking, setData, caseDetails, customerData, data, customer }) {
  const [show, setShow] = useState(false);
  const { fetchTicketHistory, ticketData } = useTicketHistory();
  const [selectSlot, setSelectSlot] = useState(null);
  const [isValid, setIsValid] = useState(true);
  const [formData, setFormData] = useState({ callResponse: null, comments: null });
  const { isLoading } = useConsultDoctor();
  const renderedComponents = [
    { name: "callResponse", value: formData.callResponse },
  ];

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => { if (caseDetails?.case_id) { fetchTicketHistory(caseDetails?.case_id); } }, [caseDetails.case_id]);
  useEffect(() => {
    if (data?.unanswered_count) {
      const current = moment();
      const lastUpdated = moment(data?.updatedAt);
      if (current.diff(lastUpdated, 'minutes') <= 45) { setIsValid(false); }
    } else { setIsValid(true); }
  }, [id]); 
 

    const medicalEscalationTickets = ticketData
    .filter(ticket => ticket.category === "customer_complaints" && (ticket.status === "Open" || ticket.status === "Pending"))
    .reverse();

  const hasTicketData = medicalEscalationTickets.length > 0 && !isLoading;
  const ticket = hasTicketData ? medicalEscalationTickets[0] : null;
  const ticketId = _.get(ticket, '_id', '');
  const sub_category = _.get(ticket, 'sub_category', '');
  const category = _.get(ticket, 'category', '');

  const disabledCondition = () => {
    let condition = false;
    switch(formData.callResponse){
      case 'dndMode': condition = formData.comments  && isEmpty(formData.comments)
      case 'languageIssue':condition = formData.comments  && isEmpty(formData.comments)
      default: condition = isEmpty(formData.comments)
    }
    return condition;
  };

  const handleChange = (value) => setFormData((prev)=> ({...prev,comments:value}))

  return (
    <>
      <Button type='primary' className="flex-1" onClick={() => handleShow("lg-down")}><Tick /></Button>
      <Offcanvas
        show={show}
        placement={"end"}
        style={{ width: DISP_FLAG ?"77%":"40%" }}
        onHide={handleClose}
      >
        <Offcanvas.Header CloseButton>
          <Offcanvas.Title>Add Feedback</Offcanvas.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={handleClose}
          />
        </Offcanvas.Header>
        <Offcanvas.Body
          style={{ maxHeight: "85vh", overflowY: "scroll" }}
          className="scrollable-container"
        >
          <div className="d-flex gap-3 flex-row">
            <div>
            {DISP_FLAG &&<DispositionComponent customer={customer} />}
            </div>
            <div className="d-flex flex-column">
            {data?.tag === "CUSTOMER_COMPLAINT_BOOKING" ? (
              <Descriptions title="User Info" bordered layout='vertical'>
                <Descriptions.Item span={2} label="Category" className='text-capitalize'>{category.replaceAll("_", " ")}</Descriptions.Item>
                <Descriptions.Item span={2} label="Sub Category" className='text-capitalize'> {sub_category.replaceAll("_", " ")}</Descriptions.Item>
                <Descriptions.Item span={3} label="Comments">{ticket?.comments?.[0]?.description}</Descriptions.Item>
              </Descriptions>
            ) : null}
            <CallResponse
              formData={formData}
              buttonStyle={buttonStyle}
              selected={selected}
              setFormData={setFormData}
              formRow={formRow}
              isValid={isValid}
              bookingId={bookingId}
            />
              {formData?.callResponse === "answered" ? (
              <div>
                    <Space.Compact block className='my-4'>
                    <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }} className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
        <Typography.Text>Answered</Typography.Text>
      </span>
      <Select
        showSearch
        placeholder='Choose one'
        style={{ width: '70%'}}
        optionFilterProp="label"
        onChange={handleChange}
        allowClear
        options={[
          {value: 'Query resolved', label: 'Query resolved' },
          {value: 'Rescheduled the slot', label: 'Rescheduled the slot'},
          {value: 'Booked a doctors call', label: 'Booked a doctors call'},
        ]}
      />
    </Space.Compact>
                {selectSlot ? (
                  <div className="fw-bold d-flex flex-row fs-1 my-2 card p-2">
                    <span>Slot booked at :</span>
                    <SoftBadge pill bg="info" className="me-2 ms-2">
                      <span style={{ fontSize: "12px" }} className="text-wrap text-break">
                        {selectSlot?.slotTime ? moment(selectSlot?.slotTime).utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss") : selectSlot}
                      </span>
                    </SoftBadge>
                  </div>
                ) : (
                  <CustomerComplaintInterventionBooking
                  setFormData={setFormData}
                  customerData={customerData} 
                  setSelectSlot={setSelectSlot}
                  ticket={ticket}
                  sub_category={sub_category}
                  />
                )}
              </div>
            ) : null}
            {formData.callResponse === "unanswered" && (
                <Space.Compact block className='my-4'>
                    <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }} className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                        <Typography.Text>Unanswered</Typography.Text>
                    </span>
                    <Select
                        showSearch
                        placeholder='Choose one'
                        style={{ width: '70%' }}
                        optionFilterProp="label"
                        onChange={handleChange}
                        allowClear
                        options={[
                          {value: 'script_unfullfill', label: 'Partially answered because not able to cover all the elements of the script !'},
                          {value: 'cx_wants_callBack', label: 'Customer pickup but wants a call back later !'},
                          {value: 'did_not_pick_up', label: 'Customer Did not Pick-Up'},
                          {value: 'dont_want_talk', label: 'Customer pickup but does not want to talk !'},
                      ]}
                    />
                </Space.Compact>
            )}
            <div>
            {[...formDisposition, 'answered'].includes(formData?.callResponse) && (
                <>
                  <SaveFeedBack
                      id={id}
                      setShow={setShow}
                      setData={setData}
                      week={week} 
                      formData={formData}
                      customerId={customerId}
                      setBooking={setBooking}
                      renderedComponents={renderedComponents}
                      disabled={disabledCondition()}
                  />
                </>
            )}
            </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default CustomerComplaintBookingDesposition;